<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-main>
    <v-container fluid fill-height>
      <v-row class="text-left messages-container justify-center align-center">
        <v-col cols="12" md="6" lg="5">
          <v-card>
            <v-card-title>{{ $t("menu.messages") }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-data-table :items="messages" hide-default-headers>
                    <template v-slot:item="props">
                      <tr>
                        <td>
                          <v-layout wrap row mb-2 mt-2>
                            <v-flex xs12 mb-2>
                              <h2>{{ props.item.name }}</h2>
                            </v-flex>
                            <v-flex xs12>
                              <h4><a :href="'mailto:' + props.item.email">{{ props.item.email }}</a></h4>
                            </v-flex>
                            <v-flex xs12 class="created">
                              {{ $t("contact.created") }} {{ props.item.created | date }}
                            </v-flex>
                          </v-layout>
                        </td>
                        <td>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" @click="showMessage(props.item)" color="primary">message</v-icon>
                            </template>
                            <span>{{ $t('contact.showMessage') }}</span>
                          </v-tooltip>
                        </td>
                        <td>
                          <v-layout wrap row justify-space-between>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon @click="openDeleteMessageDialog(props.item)"
                                        v-on="on" color="red">delete_forever</v-icon>
                              </template>
                              <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if="props.item.read" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="success">done_all</v-icon>
                              </template>
                              <span>{{ $t("contact.marked") }}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click="readMessage(props.item)" color="red">mail</v-icon>
                              </template>
                              <span>{{ $t("contact.mark") }}</span>
                            </v-tooltip>
                          </v-layout>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-dialog persistent v-model="message.dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <h3 style="margin-bottom: 20px;">{{ $t('delete') }}</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <h3>{{ $t('contact.deleteMessage') }}</h3>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="message.dialog = false">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" :loading="message.loading" :disabled="message.loading"
                     @click="deleteMessage()">{{ $t('delete') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="show.dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <h3 style="margin-bottom: 20px;">{{ $t('contact.message') }}</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <p style="color: black;">
                {{ show.message }}
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="show.dialog = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          :color="snackbar.result"
          v-model="snackbar.value"
          :bottom="true"
          :timeout="snackbar.timeout">
          {{ snackbar.text }}
          <v-btn
            color="white"
            text
            @click="snackbar.value = false">
            {{$t("close")}}
          </v-btn>
        </v-snackbar>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
  export default {
    name: 'ManageMessage',
    data() {
      return {
        show: {
          message: undefined,
          dialog: false
        },
        messages: [],
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        message: {
          selected: undefined,
          dialog: false,
          loading: false
        }
      };
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        this.$http.get('message')
          .then((body) => { this.messages = body.data; });
      },
      readMessage(message) {
        this.$http.put('message/'.concat(message.id).concat('/read'))
          .then((body) => {
            if (body.data) {
              message.read = true;
            }
          });
      },
      openDeleteMessageDialog(message) {
        this.message.selected = message;
        this.message.dialog = true;
      },
      deleteMessage() {
        this.message.loading = true;
        this.$http.delete('message/'.concat(this.message.selected.id))
          .then(() => {
            this.message.loading = false;
            this.message.dialog = false;
            this.snackbar.result = 'success';
            this.snackbar.text = this.$i18n.t('contact.deleteMessageDone');
            this.snackbar.value = true;
            this.fetchData();
          });
      },
      showMessage(contact) {
        this.show.message = contact.message;
        if (!contact.read) {
          this.readMessage(contact);
        }
        this.show.dialog = true;
      }
    }
  };
</script>

<style lang="scss">
  .messages-container {
    h2, h3 {
      font-weight: 400;
    }
    a {
      text-decoration: none;
    }
    .created {
      font-style: italic;
      font-size: 12px;
    }
  }
</style>
